export interface QuestionResult {
    question: QuizQuestion;
    correct: boolean;
    answer: Array<string>;
}

export type QuizQuestionConfig = Array<QuizQuestion>;

export interface QuizQuestion {
    minAnswers?: number;
    maxAnswers?: number;
    name: string;
    display: string;
    answers: {
        [key: string]: boolean
    };
}

export const BULL_CALL = {
    name: "bull_call_payoff",
    display: "Bull Call Payoff",
    answers: {
        make_176: true,
        lose_111: false,
        make_111: false
    }
};

export const MARGINED_CALL = {
    name: "margin_call",
    display: "Margin Call",
    answers: {
        true: true,
        false: false,
        not_sure: false
    }
};

export const MARGINED_STRATEGY = {
    name: "margined_strategies",
    display: "Margined Strategies",
    answers: {
        bull_call_spread: false,
        bear_put_spread: false,
        bull_put_spread: true,
        all_of_the_above: false
    }
};

export const MARKET_DOWN_PROTECTION = {
    name: "market_down_protection",
    display: "Market Down Protection",
    answers: {
        long_call: false,
        collar: false,
        long_put: true,
        short_call: false
    }
};

export const MONEYNESS = {
    name: "moneyness",
    display: "Moneyness",
    answers: {
        itm: true,
        otm: false,
        atm: false,
        none: false
    }
};

export const PREMIUM = {
    name: "premium",
    display: "Premium",
    answers: {
        75: false,
        7500: false,
        750: true
    }
};

export const SHORT_ATM = {
    name: "short_atm",
    display: "Short ATM",
    answers: {
        price_up_vol_up_favourable: false,
        price_down_vol_down_favourable: true,
        price_up_vol_down_favourable: false,
        price_down_vol_up_favourable: false
    }
};

export const SHORT_CALL_EXERCISED = {
    name: "short_call_exercised",
    display: "Short Call Exercised",
    answers: {
        pay: false,
        purchase_any_time: false,
        purchase_after_exercise: true,
        nothing: false
    }
};

export const STRIKE_PRICE = {
    name: "strike_price",
    display: "Strike Price",
    answers: {
        strike: true,
        iv: false,
        expiry: false,
        theta: false
    }
};

export const VOLATILITY = {
    name: "volatility",
    display: "Volatility",
    answers: {
        higher_option_price: false,
        unchanged_option_price: false,
        lower_option_price: true,
        none_of_the_above: false
    }
};

export const questions: QuizQuestionConfig = [
    BULL_CALL,
    MARGINED_CALL,
    MARGINED_STRATEGY,
    MARKET_DOWN_PROTECTION,
    MONEYNESS,
    PREMIUM,
    SHORT_ATM,
    SHORT_CALL_EXERCISED,
    STRIKE_PRICE,
    VOLATILITY
];
